import NavButton from "../atoms/NavButton";

/**
 * サイドバーのナビゲーション項目定義
 * ページを追加する場合はここに追記する
 * roles: そのページを表示してよい userType の一覧（RegiInfo.UserType: shop/office/develop）
 */
const NAV_ITEMS = [
  { id: "store", label: "店舗入力画面", roles: ["shop", "develop"] },
  { id: "monthly", label: "月毎データ一覧", roles: ["shop", "develop"] },
  { id: "office", label: "全店舗データ管理画面", roles: ["office", "develop"] },
  { id: "comments", label: "全店舗コメント確認画面", roles: ["office", "develop"] },
  { id: "account", label: "アカウント管理", roles: ["shop", "office", "develop"] },
];

/**
 * Sidebar - サイドバーナビゲーション
 *
 * サイズ・フォント系は上位コンポーネントから props で受け取る。
 * デフォルト値は通常の使用に合わせた値を設定してある。
 *
 * @param {string} currentPage           - 現在表示中のページID
 * @param {function} onPageChange        - ページ切替ハンドラ
 * @param {string} userType              - ログイン中ユーザーの権限区分（shop/office/develop）。該当ページのみ表示する
 * @param {string} widthClass            - サイドバーの幅クラス (例: 'w-36')
 * @param {string} navButtonPaddingClass - NavButton の padding クラス
 * @param {string} navButtonTextSizeClass - NavButton の font-size クラス
 */
function Sidebar({
  currentPage,
  onPageChange,
  userType,
  widthClass = "w-36",
  navButtonPaddingClass,
  navButtonTextSizeClass,
}) {
  const visibleItems = NAV_ITEMS.filter((item) => item.roles.includes(userType));

  return (
    <aside
      className={`${widthClass} border-r border-gray-300 flex-shrink-0 flex flex-col gap-1 pt-2 sticky top-0 h-screen overflow-y-auto`}
    >
      {visibleItems.map((item) => (
        <NavButton
          key={item.id}
          label={item.label}
          isActive={currentPage === item.id}
          onClick={() => onPageChange(item.id)}
          paddingClass={navButtonPaddingClass}
          textSizeClass={navButtonTextSizeClass}
        />
      ))}
    </aside>
  );
}

export default Sidebar;
